// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div id="benefits" />
      <h1>Benefits Intake</h1>
      <h2 id="october-7th%2C-2019">October 7th, 2019</h2>
      <p>(v0 &amp; v1) Add support for base64 encoding <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3395">#3995</a></p>
      <hr />
      <h2 id="july-29%2C-2019">July 29, 2019</h2>
      <p>(v0 &amp; v1) New <code>expired</code> status added to individual status endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3353">#3353</a></p>
      <hr />
      <h2 id="august-19%2C-2019">August 19, 2019</h2>
      <p>(v0 &amp; v1) Validation on document page size <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3213">#3213</a></p>
      <hr />
      <h2 id="july-24%2C-2019">July 24, 2019</h2>
      <p>(v0 &amp; v1) Cache statuses for /uploads/report endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3158">#3158</a></p>
      <hr />
      <h2 id="july-11th%2C-2019">July 11th, 2019</h2>
      <p>(v1) Revert changes to error handling <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3150">#3150</a></p>
      <hr />
      <h2 id="july-9th%2C-2019">July 9th, 2019</h2>
      <p>(v1) Announced support for v1, which includes 2 breaking changes:</p>
      <ul>
      <li>&quot;vbms&quot; status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3027">#3027</a></li>
      <li>Updates to error handling <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3053">#3053</a></li>
      </ul>
      <hr />
      <h2 id="june-11%2C-2019">June 11, 2019</h2>
      <p>(v0 &amp; v1) Adding Metadata Endpoints for V0 and V1 end points <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3093">#3093</a></p>
      <hr />
      <h2 id="june-3%2C-2019">June 3, 2019</h2>
      <p>(v0) Upgrade Ruby to 2.4.5 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2995">#2995</a></p>
      <hr />
      <h2 id="may-28%2C-2019">May 28, 2019</h2>
      <p>(v0) Rails 5.2.3 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2933">#2933</a></p>
      <hr />
      <h2 id="may-23%2C-2019">May 23, 2019</h2>
      <p>(v0) Create self-service testing tool <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3059">#3059</a></p>
      <hr />
      <h2 id="may-3%2C-2019">May 3, 2019</h2>
      <p>(v0) Validate Against Empty Files <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3025">#3025</a></p>
      <hr />
      <h2 id="may-1%2C-2019">May 1, 2019</h2>
      <p>(v0) Rails 5.1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2897">#2897</a></p>
      <hr />
      <h2 id="april-9%2C-2019">April 9, 2019</h2>
      <p>(v0) Upgrade API to Rails 5.0.7.2 [#2833](Upgrade API to Rails 5.0.7.2 (#2833)</p>
      <hr />
      <h2 id="march-18%2C-2019">March 18, 2019</h2>
      <p>(v0) Handle new vbms success status without passing it along to consumers (would be a breaking change) <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2877">#2877</a></p>
      <hr />
      <h2 id="january-28%2C-2019">January 28, 2019</h2>
      <p>(v0) Status simulation in Developer environment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2751">#2751</a></p>
      <ul>
      <li>Can now specify status in developer environment, and receive mocked data for that status.</li>
      </ul>
      <hr />
      <h2 id="october-8%2C-2018">October 8, 2018</h2>
      <p>(v0) Update API URLs to va.gov domains in documentation <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2332">#2332</a></p>
      <hr />
      <h2 id="september-18%2C-2018">September 18, 2018</h2>
      <p>(v0) Implement VA-required logging for uploads <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2072">#2072</a></p>
      <hr />
      <h2 id="august-27%2C-2018">August 27, 2018</h2>
      <p>(v0) Validating PDF format on upload <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2213">#2213</a></p>
      <hr />
      <h2 id="july-23%2C-2018">July 23, 2018</h2>
      <p>(v0) Limit the size of individual attachments in uploads <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2094">#2094</a></p>
      <hr />
      <h2 id="july-19%2C-2018">July 19, 2018</h2>
      <ul>
      <li>(v0) Improve pension and burial claim uploads to Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2143">#2143</a></li>
      <li>(v0) Add Consumer ID to Central Mail upload submission <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2071">#2071</a></li>
      </ul>
      <hr />
      <h2 id="july-2%2C-2018">July 2, 2018</h2>
      <p>(v0) Add Amazon SNS support to endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2058">#2058</a></p>
      <hr />
      <h2 id="june-8%2C-2018">June 8, 2018</h2>
      <p>(v0) Add numeric-characters-only validation to fileNumber metadata element <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2020">#2020</a></p>
      <hr />
      <h2 id="may-17%2C-2018">May 17, 2018</h2>
      <p>(v0) Add bulk status report <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1947">#1947</a></p>
      <hr />
      <h2 id="may-8%2C-2018">May 8, 2018</h2>
      <p>(v0) Start uploading documents to Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1896">#1896</a></p>
      <hr />
      <h2 id="april-26%2C-2018">April 26, 2018</h2>
      <p>(v0) Start retrieving statuses from Central Mail <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1887">#1887</a></p>
      <hr />
      <h2 id="april-20%2C-2018">April 20, 2018</h2>
      <p>(v0) Create initial service <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1887">#1887</a></p>
      <hr />
      <br />
      <div id="appeals" />
      <h1>Appeals Status</h1>
      <h2 id="january-31%2C-2019">January 31, 2019</h2>
      <p>Add Power of Attorney verification for future Appeals Version 1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2717">#2717</a></p>
      <hr />
      <h2 id="january-14%2C-2019">January 14, 2019</h2>
      <p>Bug discovered and fixed for safe null requests <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2727">#2727</a></p>
      <hr />
      <h2 id="june-11%2C-2018">June 11, 2018</h2>
      <p>Implement VA-required headers to retrieve status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2024">#2024</a></p>
      <hr />
      <h2 id="may-23%2C-2018">May 23, 2018</h2>
      <p>Add appeals service API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1961">#1961</a></p>
      <hr />
      <br />
      <div id="claims" />
      <h1>Benefits Claims</h1>
      <h2 id="november-27%2C-2019">November 27, 2019</h2>
      <p>(v0) Add &quot;claimDate&quot; field to set receipt dates for internal consumers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3596">#3596</a></p>
      <hr />
      <h2 id="november-20%2C-2019">November 20, 2019</h2>
      <p>(v1) Require attachment for original claims submitted by representatives <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3554">#3554</a></p>
      <hr />
      <h2 id="november-12%2C-2019">November 12, 2019</h2>
      <p>(v1) Validate existence of previous claim to determine &quot;original claim&quot; status and require attachment in those cases <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3471">#3471</a></p>
      <hr />
      <h2 id="september-24%2C-2019">September 24, 2019</h2>
      <p>(v0 &amp; v1) Add &quot;autoCestPDFGenerationDisabled&quot; boolean field <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3328">#3328</a></p>
      <hr />
      <h2 id="july-23%2C-2019">July 23, 2019</h2>
      <p>(v1) Announced production support for external use of v1, allowing:</p>
      <ul>
      <li>Users with existing Power of Attorney to establish 526 claims on a Veteran's behalf</li>
      <li>Authenticated Veterans to establish 526 claims on their own behalf</li>
      </ul>
      <hr />
      <h2 id="june-25%2C-2019">June 25, 2019</h2>
      <p>Creating ITF expiration validation for 526 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3119">#3119</a></p>
      <hr />
      <h2 id="june-17%2C-2019">June 17, 2019</h2>
      <p>Add supporting documents to claims <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3111">#3111</a></p>
      <hr />
      <h2 id="june-10%2C-2019">June 10, 2019</h2>
      <p>Add machine readable source to errors <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3097">#3097</a></p>
      <hr />
      <h2 id="june-3%2C-2019-2">June 3, 2019</h2>
      <ul>
      <li>Add a couple specs for empty ITF requests <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3083">#3083</a></li>
      <li>Upgrade Ruby to 2.4.5 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2995">#2995</a></li>
      </ul>
      <hr />
      <h2 id="may-30%2C-2019">May 30, 2019</h2>
      <ul>
      <li>Adding logic to match claims detail and auto claim serializers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3061">#3061</a></li>
      <li>Adding Form Schema documentation and json api compliance <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3075">#3075</a></li>
      </ul>
      <hr />
      <h2 id="may-28%2C-2019-2">May 28, 2019</h2>
      <ul>
      <li>Rails 5.2.3 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2933">#2933</a></li>
      <li>Get request for displaying JSON Schema for each form <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3072">#3072</a></li>
      </ul>
      <hr />
      <h2 id="may-20%2C-2019">May 20, 2019</h2>
      <ul>
      <li>(v1) Claims docs fix <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3055">#3055</a></li>
      <li>(v1) add edipi to from_identity call <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3047">#3047</a></li>
      </ul>
      <hr />
      <h2 id="may-1%2C-2019-2">May 1, 2019</h2>
      <ul>
      <li>(v1) Art.claims 404 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3015">#3015</a></li>
      <li>(v1) Rails 5.1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2897">#2897</a></li>
      </ul>
      <hr />
      <h2 id="april-30%2C-2019">April 30, 2019</h2>
      <p>(v1) Creating Swagger Blocks Documentation for Claims V1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2952">#2952</a></p>
      <hr />
      <h2 id="april-23%2C-2019">April 23, 2019</h2>
      <ul>
      <li>(v1) Check PoA with Okta <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2990">#2990</a></li>
      <li>(v1) Intent To File Claims Api <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2990">#2990</a></li>
      </ul>
      <hr />
      <h2 id="april-17%2C-2019">April 17, 2019</h2>
      <p>(v1) Art.claims api schema <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2965">#2965</a></p>
      <hr />
      <h2 id="april-12%2C-2019">April 12, 2019</h2>
      <p>(v1) Verify PoA from OGC data <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2951">#2951</a></p>
      <hr />
      <h2 id="april-11%2C-2019">April 11, 2019</h2>
      <p>(v1) Add ability to set users from oauth token or headers <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2949">#2949</a></p>
      <hr />
      <h2 id="april-9%2C-2019-2">April 9, 2019</h2>
      <ul>
      <li>(v1) Upgrade API to Rails 5.0.7.2 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2833">#2833</a></li>
      <li>(v1 )Uploading Uploads to EVSS for Auto-CEST <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2915">#2915</a></li>
      <li>(v1) 526 Additional Validations <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2936">#2936</a></li>
      </ul>
      <hr />
      <h2 id="april-5%2C-2019">April 5, 2019</h2>
      <p>(v1) Split off Claims v1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2927">#2927</a></p>
      <hr />
      <h2 id="march-26%2C-2019">March 26, 2019</h2>
      <p>(v0) Create mock override to test auto-establishment in staging <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2908">#2908</a></p>
      <ul>
      <li>Our upstream partners limit the number of test submissions allowed in staging, so we now use mocked data by default.</li>
      </ul>
      <hr />
      <h2 id="march-21%2C-2019">March 21, 2019</h2>
      <p>(v0) Fix security vulnerability in disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2903">#2903</a></p>
      <hr />
      <h2 id="march-20%2C-2019">March 20, 2019</h2>
      <p>(v0) Fix duplicate submissions for disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2852">#2852</a></p>
      <hr />
      <h2 id="march-18%2C-2019-2">March 18, 2019</h2>
      <p>(v0) Add support for uploading documents to auto-established disability compensation claims <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2868">#2868</a></p>
      <hr />
      <h2 id="march-15%2C-2019">March 15, 2019</h2>
      <p>(v0) Improve Veteran lookup for disability claim auto-establishment and claim status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2863">#2863</a></p>
      <hr />
      <h2 id="january-8%2C-2019">January 8, 2019</h2>
      <p>(v0) Implement initial VA internal-only disability claim auto-establishment <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2824">#2824</a></p>
      <hr />
      <h2 id="january-8%2C-2019-2">January 8, 2019</h2>
      <p>(v0) Implement Power of Attorney lookup for future v1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2709">#2709</a></p>
      <hr />
      <h2 id="january-4%2C-2019">January 4, 2019</h2>
      <p>(v0) Update claim statuses to be consistent with VA.gov <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2701">#2701</a></p>
    </div>
  );
};

export default MarkdownComponent;
